import React from 'react'
import { Card, Space, Row, Col, Typography, Image } from 'antd';
import { CheckCircleFilled, CloseCircleFilled } from '@ant-design/icons';
import CorrectKk from '../../assets/img/KK benar.jpg';
import IncorrectKk from '../../assets/img/kk salah.jpg';

const { Text } = Typography;

export default function InfoKk() {
    return (
        <Card className='border-radius-6'>
            <Row>
                <Col span={24}>
                    <Row>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={16} align='center'>
                                <CheckCircleFilled style={{fontSize: 25, color:'green'}} />
                                <Image src={CorrectKk} width="100%" height={165} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col className='text-align-center' span={12}>
                            <Space direction="vertical" size={12} align='center'>
                                <CloseCircleFilled style={{fontSize: 25, color:'red'}} />
                                <Image src={IncorrectKk} width="100%" height={175} preview={false} style={{ objectFit: 'contain' }} />
                            </Space>
                        </Col>
                        <Col span={24}>
                            <Space direction="vertical" size={0}>
                                <Text type="secondary">Persyaratan Dokumen : </Text>
                                <Text type="secondary">• Dokumen dalam format <Text className='dark-color' strong>PDF</Text></Text>
                                <Text type="secondary">• Dokumen tidak terhalang objek, seperti tangan</Text>
                                <Text type="secondary">• Dokumen terlihat jelas</Text>
                            </Space>
                        </Col>
                    </Row>
                </Col>
            </Row>
        </Card>
    )
}
